export const getFilteredData = (emissionsData, selectedDataQualityFilters = []) => {
  let filtered = emissionsData;

  if (selectedDataQualityFilters.length > 0) {
    filtered = filtered.filter((item) =>
      selectedDataQualityFilters.some((filter) => filter.toLowerCase() === item.dataQuality.toLowerCase())
    );
  }

  return filtered;
};

export const transformBarData = (emissionData, selectedScopeFilters, years) => {
  const transformData = (data, emissionTypes = ["totalCo2Emissions"]) => {
    return data?.map((el) => {
      const transformedEntry = { supplier: el.supplierName };
      years.forEach((year) => {
        transformedEntry[year] = emissionTypes.reduce((sum, type) => {
          return sum + (el?.yearlyEmissionData?.[year]?.[type] || 0);
        }, 0);
      });
      return transformedEntry;
    });
  };

  let emissionTypes = ["totalCo2Emissions"];
  if (selectedScopeFilters.length > 0) {
    emissionTypes = selectedScopeFilters;
  }

  return transformData(emissionData, emissionTypes);
};
